import React from 'react';
import Icon from '../../../components/AppIcon';

const OnboardingProgress = ({ currentStep = 2 }) => {
  const steps = [
    { id: 1, title: "Company Selection", icon: "Building2", completed: true },
    { id: 2, title: "Company Overview", icon: "Eye", completed: false, current: true },
    { id: 3, title: "Registration Form", icon: "FileText", completed: false },
    { id: 4, title: "Profile Setup", icon: "User", completed: false }
  ];

  return (
    <div className="bg-card border-b border-border sticky top-0 z-40 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Icon name="Route" size={20} color="var(--color-primary)" />
            <span className="text-sm font-medium text-foreground">Onboarding Progress</span>
          </div>
          
          <div className="hidden md:flex items-center gap-2">
            {steps?.map((step, index) => (
              <React.Fragment key={step?.id}>
                <div className={`flex items-center gap-2 px-3 py-2 rounded-lg transition-colors ${
                  step?.completed ? 'bg-success/10 text-success' : step?.current ?'bg-primary/10 text-primary': 'bg-muted/50 text-muted-foreground'
                }`}>
                  <div className={`w-6 h-6 rounded-full flex items-center justify-center ${
                    step?.completed ? 'bg-success' : step?.current ?'bg-primary': 'bg-muted'
                  }`}>
                    {step?.completed ? (
                      <Icon name="Check" size={14} color="white" />
                    ) : (
                      <span className="text-xs font-semibold text-white">{step?.id}</span>
                    )}
                  </div>
                  <span className="text-sm font-medium">{step?.title}</span>
                </div>
                
                {index < steps?.length - 1 && (
                  <Icon name="ChevronRight" size={16} color="var(--color-muted-foreground)" />
                )}
              </React.Fragment>
            ))}
          </div>
          
          <div className="flex items-center gap-2">
            <div className="text-right hidden sm:block">
              <p className="text-xs text-muted-foreground">Step {currentStep} of {steps?.length}</p>
              <div className="w-24 h-1.5 bg-muted rounded-full overflow-hidden mt-1">
                <div 
                  className="h-full bg-primary transition-all duration-300"
                  style={{ width: `${(currentStep / steps?.length) * 100}%` }}
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OnboardingProgress;